const useMyActivitiesTabStepModifier = ({ step }) => {
	const hideResponsiblePerson = true;

	return { ...step, hideResponsiblePerson };
};

export default useMyActivitiesTabStepModifier;
